import { useLocation } from 'react-router';
import { TransitionGroup, CSSTransition } from 'react-transition-group';


const Body = ({ children }) => {

  const location = useLocation();

  return (
    <TransitionGroup component={null}>
      <CSSTransition
        key={location.key}
        timeout={{
          appear: 500,
          enter: 500,
          exit: 650
        }}
        classNames={{
          appear: 'ng-appear',
          appearActive: 'ng-appear-active',
          appearDone: 'ng-appear-done',
          enter: 'ng-enter',
          enterActive: 'ng-enter-active',
          enterDone: 'ng-enter-done',
          exit: 'ng-leave',
          exitActive: 'ng-leave-active',
          exitDone: 'ng-leave-done'
        }}
      >
        {children}
      </CSSTransition>
    </TransitionGroup>
  );
};

export default Body;